import { render, staticRenderFns } from "./paymentPortal.vue?vue&type=template&id=6985bab5&"
import script from "./paymentPortal.vue?vue&type=script&lang=js&"
export * from "./paymentPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports